import ComponentProps from "../components/components-props";
import IconsList from "../components/icons-list";

export default {
  ComponentProps,
  IconsList,
};
